import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SimpleContent.module.scss';
import clsx from 'clsx';
import Block from '../Block/Block';
const SimpleContent = ({ title, children, className }) => {
  return (
    <>
      <Block title={title} classNameTitle={''} line className={clsx(styles.content, className)}>
        {children}
      </Block>
    </>
  );
};

export default SimpleContent;
